import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-login-mall",
  "use": "icon-login-mall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-login-mall\"><path d=\"M832 384a192 192 0 0 0 192-192 192 192 0 0 0-192-192C256 0 0 960 0 960v32a32 32 0 0 0 64 0V960c40.832-122.496 140.16-244.736 256.512-354.624 0 0.96-0.512 1.664-0.512 2.624a96 96 0 1 0 192 0c0-16.128-4.992-30.656-12.032-44.032 13.376 7.04 27.904 12.032 44.032 12.032 52.992 0 96-43.008 96-96 0-16.128-4.992-30.656-12.032-44.032 13.376 7.04 27.84 12.032 44.032 12.032 46.528 0 83.456-33.664 92.224-77.568 21.12 8.192 43.712 13.568 67.776 13.568z\" p-id=\"3334\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/login-mall.svg
// module id = xzZT
// module chunks = 20